import { type AxiosInstance } from "axios";
import { type AcquiredRequestsResponse } from "../types";

export const ACQUIRED_REQUESTS_ENDPOINT = "/picture-request/acquired-requests";

/** 物件検索と同じ条件で依頼を検索し、依頼単位のページを取得する。 */
export const getAcquiredRequests = async (
  apiClient: AxiosInstance,
  params: Record<string, string | number | boolean>
): Promise<AcquiredRequestsResponse> => {
  const { data } = await apiClient.get<AcquiredRequestsResponse>(
    ACQUIRED_REQUESTS_ENDPOINT,
    { params }
  );
  return data;
};
